export const isNumeric = (val: any) => {
  return /^-?\d+$/.test(val);
};
